<template>
  <el-container class="body-wrap">
    <el-header height="84px">
      <v-head></v-head>
    </el-header>
    <el-main class="w-main" :class="{'content-collapse':collapse}">
      <!-- <div class="w1200"> -->
        <router-view></router-view>
      <!-- </div> -->
    </el-main>
    <div class="footer">
      <!-- <div class="tel">在办理保函过程中，如您遇到问题，请及时拨打咨询400-666-7151</div> -->
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">CopyRight©{{name}} All Rights Reserved 京ICP备<span>{{icp}}</span></a><span class="redzi">咨询电话{{servicePhone}}</span><!--400-666-7151-->
    </div>
    <zixuntool @totop="backTop" :tradingCenter=jyzxid></zixuntool>
  </el-container>
</template>
<script>
import auth from '@/utils/auth'
import utils from '@/utils/utils'
import vHead from './Header.vue'
import bus from './bus'
import zixuntool from '@/components/page/filetools/zixuntool.vue'
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
      name: '',
      icp: '',
      jyzxid: '',
      servicePhone:''
    }
  },
  components: {
    vHead,
    zixuntool,
  },
  created() {
    this.name = utils.getName()
    this.icp = utils.getICP()
    bus.$on('collapse', (msg) => {
      this.collapse = msg
    })

    //console.log('UserCenter交易中心--->' + JSON.stringify(this.$route.query.incmpid))
    //console.log('UserCenter公共方法去的交易中心---->' + JSON.stringify(auth.getInCmpId()))
    this.jyzxid = this.$route.query.incmpid // 交易中心
    if (
      this.$route.query.incmpid == null ||
      this.$route.query.incmpid == '' ||
      this.$route.query.incmpid == 'undefined'
    ) {
      this.jyzxid = auth.getInCmpId()
    }

    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', (msg) => {
      let arr = []
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name)
      }
      this.tagsList = arr
    })

    // if(utils.verifyDate()){
      this.servicePhone = '400-666-7151'
    // }else{
    //   this.servicePhone = '15555519973'
    // }
  },
  methods: {
    //返回顶部事件
    backTop() {
      //   console.log('点击！！')
      document.getElementsByClassName('w-main')[0].scrollTop = 0
    },
  },
}
</script>
<style scoped>
.body-wrap {
  /* height: 100%; */
  /* background: #fff; */
  overflow-y: hidden;
  height: 100vh;

  /* background: #f5f6f8; */
}
.el-header {
  padding: 0;
  margin: 0;
}
.w-main {
  /* background-image: url(../../../static/img/banner.png);
  background-position: 0 0;
  background-size: 100% auto;
  background-repeat: no-repeat; */
  /* margin-top: 5px; */
  height: calc(100vh - 160px);
  /* margin-top: 20px; */
  /* padding: 20px 0 0 0; */
  width: 100%;
  /* overflow: hidden; */
  /* background-color: #f5f6f8; */
  overflow-y: auto;
}
/* .w1200{background-color: #fff;} */
.el-main {padding: 0;
  background-color: #f5f5f5;
  /* padding: 15px; */
  /* background: #fff; */
}
.el-footer {
  padding-top: 15px;
  text-align: center;
  color: #f00;
  /* background: #fff; */
}
.footer {
  padding: 30px 0 10px 0;
  background-color: #fff;
  /* border-top: 2px solid #1f55a5; */
  /* background-color: #f7f7f7; */
  text-align: center;
}
.footer .tel {
  display: block;
  padding: 5px 10px;
  color: #f00;
}
.footer a {
  display: inline-block;
  padding: 0 5px;
  color: #777;
}
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter.vue